module.exports = __webpack_public_path__ + "static/media/desc.f0b764d8.jpeg";